// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_k5-0";
export var buttonContainer = "_k5-3";
export var cancelButton = "_k5-4";
export var headerSection = "_k5-6";
export var headerTitle = "_k5-9";
export var messageSideLeft = "_k5-1";
export var messageSideRight = "_k5-2";
export var orderNumberContainer = "_k5-7";
export var orderNumberLabel = "_k5-8";
export var submitButton = "_k5-5";